<template>
  <div id="book-detail" v-if="reading">
    <div class="book-info" style="display: flex;">
      <div class="book-cover">
        <img :src="reading.cover" style="width: 252px;height: 332px;border-radius: 5px;">
      </div>
      <div class="book-info-right" style="margin-left:20px;width: 500px;">
        <el-form>
          <el-form-item label="读本名称">
            <span>{{ reading.name }}</span>
          </el-form-item>
          <el-form-item label="教材简介">
            <div>{{ reading.description }}</div>
          </el-form-item>
          <el-form-item label="创建时间">
            <span>{{ reading.createTime }}</span>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="action-part">
      <el-form :inline="true">
        <el-form-item>
          <el-button type="primary" size="medium" @click="showEditor(null)">创建问答</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="reading-item-list">
      <el-table
          border
          :data="resultList"
          style="width: 100%">
        <el-table-column
            width="400"
            align="center"
            label="配图">
          <template slot-scope="scope">
            <img :src="item" :key="index" v-for="(item,index) in scope.row.images"
                 style="margin-right:5px;border-radius:5px;width: 63px;height: 83px;">
          </template>
        </el-table-column>
        <el-table-column
            prop="question"
            label="问题">
        </el-table-column>
        <el-table-column
            width="180"
            align="center"
            label="音频">
          <template slot-scope="scope">
            <el-button @click="playMp3(scope.row)" size="small" type="info">播放</el-button>
          </template>
        </el-table-column>
        <el-table-column
            prop="ord"
            label="排序"
            align="center"
            width="180">
        </el-table-column>
        <el-table-column
            width="180"
            align="center"
            label="是否可用">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.enable" active-value="1" inactive-value="0"
                       @change="onItemEnableChange(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column
            prop="answer"
            align="center"
            width="80"
            label="答案">
        </el-table-column>
        <el-table-column
            prop="createTime"
            width="180"
            label="创建时间">
        </el-table-column>
        <el-table-column
            align="center"
            width="200"
            label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="medium" @click="showEditor(scope.row)">编辑</el-button>
            <el-popconfirm
                confirm-button-text='马上删除'
                cancel-button-text='我后悔了'
                icon="el-icon-info"
                @confirm="deleteItem(scope.row)"
                icon-color="red"
                title="确定删除该内容吗？">
              <el-button slot="reference" type="danger" style="margin-left: 10px;" size="medium">
                删除
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="dialog-part">
      <el-dialog
          :title="dialogText"
          :visible.sync="isEditorShow"
          center
          width="600px">
        <div>
          <el-form label-width="80px" size="medium">
<!--            <el-form-item label="模块" :required="true">-->
<!--              <el-cascader-->
<!--                  clearable-->
<!--                  v-model="selectModuleIds"-->
<!--                  :options="appModuleTreeData"-->
<!--                  :props="{ checkStrictly: true, value: 'id', label: 'name' }"-->
<!--                  :show-all-levels="true"-->
<!--                  @change="() => {}" placeholder="请选择数据的模块"></el-cascader>-->
<!--            </el-form-item>-->
            <el-form-item
                label="问题" :required="true">
              <el-input type="textarea" v-model="readingTest.question" maxlength="256"
                        :show-word-limit="true"
                        placeholder="请输入问题，建议不超过30个字"></el-input>
            </el-form-item>
            <el-form-item
                label="音频" :required="true">
              <div class="form-item-container">
                <el-upload
                    accept="audio/mpeg"
                    action=""
                    :show-file-list="false"
                    :http-request="uploadMp3">
                  <el-button type="primary"
                             v-text="readingTest.mp3Id===''?'上传音频':'更新音频'"></el-button>
                  <span class="upload-item-text"
                        v-if="readingTest.mp3Name!==''">{{ readingTest.mp3Name }}</span>
                </el-upload>
              </div>
              <div class="form-des-text">
                MP3格式，大小不超过10M
              </div>
            </el-form-item>
            <el-form-item
                label="图片" :required="true">
              <div class="form-item-container">
                <div class="image-list-preview" v-for="(item,index) in readingTest.images" :key="index">
                  <img style="width: 100px;height: 100px;vertical-align:middle;
                                            border-radius: 4px; object-fit: cover;border: rgba(0,0,0,.08) 1px dashed;margin-right: 5px;" :src="item"  alt="image"/>
                  <div class="image-action-part">
                    <span class="el-icon-view" @click="showImagePreview(item)"></span>
                    <span class="el-icon-delete" @click="doImageListItemDelete(index)"></span>
                  </div>
                </div>
                <el-upload
                    v-if="readingTest.images.length < 3"
                    action=""
                    style="display:inline-block;"
                    accept="image/jpeg,image/png,image/jpg"
                    :show-file-list="false"
                    :http-request="uploadPic">
                  <div class="image-upload-cover">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </div>
                </el-upload>
              </div>
              <div class="form-des-text">
                支持JPEG/PNG，单张不超过2M，最少3张
              </div>
            </el-form-item>
            <el-form-item
                label="答案" :required="true">
              <el-input-number v-model="readingTest.answer" :min="1" :max="readingTest.images.length"></el-input-number>
            </el-form-item>
            <el-form-item
                label="顺序" :required="true">
              <el-input-number v-model="readingTest.ord" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item label="上架">
              <el-switch v-model="readingTest.enable" active-value="1" inactive-value="0"></el-switch>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
                  <el-button @click="onEditorCancel" size="medium">取 消</el-button>
                  <el-button type="primary" @click="onEditorConfirm" size="medium">提 交</el-button>
                </span>
      </el-dialog>
      <el-dialog :visible.sync="imagePreviewShow">
        <img width="100%" :src="previewImageUrl" alt="图片">
      </el-dialog>
    </div>
    <audio :src="targetPlayUrl" id="audio"></audio>
  </div>
</template>
<script>
import * as api from '../../api/api';

export default {
  data() {
    return {
      readingTest: {
        id: '',
        readingId: '',
        readingItemId: '',
        mp3Id: '',
        question: '',
        images: [],
        ord: 0,
        answer: 1,
        enable: '1',
        mp3Name: '',
        moduleId: '0'
      },
      selectModuleIds: [],
      appModuleTreeData: [],
      reading: null,
      targetPlayUrl: '',
      readingId: '',
      readingItemId: '',
      resultList: [],
      dialogText: '',
      imagePreviewShow: false,
      previewImageUrl: '',
      isEditorShow: false
    }
  },
  methods: {
    onItemEnableChange() {

    },
    doImageListItemDelete(index) {
      this.readingTest.images.splice(index, 1);
    },
    showImagePreview(url) {
      this.imagePreviewShow = true;
      this.previewImageUrl = url;
    },
    deleteItem(item) {
      let itemId = item.id;
      api.deleteReadingTest(itemId).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.$message.success(result.msg);
          this.listGroup();
        } else {
          this.$message.error(result.msg);
        }
      })
    },
    playMp3(item) {
      let mp3Id = item.mp3Id;
      api.getMp3PlayToken(mp3Id).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.targetPlayUrl = result.data.url;
          let audio = document.getElementById('audio');
          if (audio) {
            this.$nextTick(function () {
              audio.play();
            });
          }
        } else {
          this.$message.error(result.msg)
        }
      });
    },
    uploadReadingItemCover(object) {
      let formData = new FormData();
      formData.append('image', object.file);
      api.postReadingCover(formData).then((result) => {
        if (result.code === api.SUCCESS_CODE) {
          let url = result.data;
          this.$message({
            message: '读本封面上传成功.',
            type: 'success',
            center: true
          });
          this.readingItem.image = url;
        } else {
          this.$message.error(result.msg);
        }
      }).catch((err) => {
        console.log(err);
        this.$message({
          message: '读本封面上传出错',
          type: 'error',
          center: true
        })
      })
    },
    onEditorConfirm() {
      this.readingTest.readingId = this.readingId;
      this.readingTest.readingItemId = this.readingItemId;
      //检查内容
      if (this.readingTest.question === '') {
        return this.$message.error("请输入问题.");
      }

      if (this.readingTest.mp3Id === '') {
        return this.$message.error("请上传问题的音频.");
      }

      if (this.readingTest.images.length === 0) {
        return this.$message.error("请上传配套的图片.");
      }

      this.readingTest.moduleId = this.selectModuleIds[this.selectModuleIds.length - 1];
      if (this.readingTest.id !== '') {
        //更新内容
        api.updateReadingTest(this.readingTest).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.listGroup();
            this.onEditorCancel();
            this.$message.success(result.msg)
          } else {
            this.$message.error(result.msg)
          }
        })
      } else {
        //新创建内容
        api.postReadingTest(this.readingTest).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.listGroup();
            this.onEditorCancel();
            this.$message.success(result.msg)
          } else {
            this.$message.error(result.msg)
          }
        })
      }
    },
    uploadPic(object) {
      let formData = new FormData();
      formData.append('image', object.file);
      api.postReadingTestImage(formData).then((result) => {
        if (result.code === api.SUCCESS_CODE) {
          let url = result.data;
          this.$message({
            message: '图片上传成功.',
            type: 'success',
            center: true
          });
          this.readingTest.images.push(url);
        } else {
          this.$message.error(result.msg);
        }
      }).catch((err) => {
        console.log(err);
        this.$message({
          message: '上传图片出错',
          type: 'error',
          center: true
        })
      })
    },
    onEditorCancel() {
      this.isEditorShow = false;
      this.readingTest.id = '';
      this.readingTest.readingId = '';
      this.readingTest.mp3Id = '';
      this.readingTest.question = '';
      this.readingTest.images = [];
      this.readingTest.ord = 0;
      this.readingTest.answer = 1;
      this.readingTest.enable = '1';
      this.readingTest.mp3Name = '';
      this.readingTest.moduleId = '0';
    },
    uploadMp3(object) {
      let formData = new FormData();
      formData.append('mp3', object.file);
      api.postMp3(formData).then((result) => {
        if (result.code === api.SUCCESS_CODE) {
          let url = result.data;
          this.$message({
            message: 'mp3上传成功.',
            type: 'success',
            center: true
          });
          this.readingTest.mp3Id = url;
          this.readingTest.mp3Name = object.file.name;
        } else {
          this.$message.error(result.msg);
        }
      }).catch((err) => {
        console.log(err);
        this.$message({
          message: '上传mp3出错',
          type: 'error',
          center: true
        })
      })
    },
    showEditor(item) {
      this.selectModuleIds = [];
      if (item) {
        this.readingTest.id = item.id;
        this.readingTest.readingId = item.readingId;
        this.readingTest.readingItemId = item.readingItemId;
        this.readingTest.mp3Id = item.mp3Id;
        this.readingTest.question = item.question;
        this.readingTest.images = item.images;
        this.readingTest.ord = item.ord;
        this.readingTest.answer = item.answer;
        this.readingTest.enable = item.enable;
        this.readingTest.mp3Name = item.mp3Name;
        this.selectModuleIds.push(item.moduleId)
        this.dialogText = '更新内容';
      } else {
        this.dialogText = '创建内容';
      }
      this.isEditorShow = true;
    },
    listGroup() {
      api.listReadingTest(this.readingId, this.readingItemId).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.resultList = result.data;
        }
      })
    },
    getReadingDetail() {
      api.getReading(this.readingId).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.reading = result.data;
          this.listGroup();
        }
      })
    }
  },
  mounted() {
    this.readingId = this.$route.query.readingId;
    this.readingItemId = this.$route.query.readingItemId;
    if (this.readingId) {
      this.getReadingDetail();
    }

  }
}
</script>
<style scoped>
.action-part {
  margin-top: 20px;
}

.reading-cover img {
  width: 200px;
  height: 200px;
  border: 5px;
}

.image-upload-cover {
  text-align: center;
  cursor: pointer;
  line-height: 100px;;
  margin-right: 20px;
  width: 100px;
  height: 100px;
  border-radius: 4px;
  border: #DCDFE6 dashed 2px;
}

.image-upload-cover img {
  width: 100%;
  height: 100%;
}

.image-list-preview {
  display: inline-block;
  text-align: center;
  position: relative;
}


.image-action-part:hover {
  opacity: 1;
}

.image-action-part {
  position: absolute;
  display: flex;
  justify-content: space-around;
  align-items: center;
  opacity: 0;
  background: rgba(0, 0, 0, .1);
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

</style>
